export default "__VITE_ASSET__64d033e8__"